import { ANNUAL_LIMIT_PERCENTAGE } from '../constants';

export const hasReachedAnnualConsumptionLimit = (annualConsumptionPercentage = 0): boolean =>
  annualConsumptionPercentage >= ANNUAL_LIMIT_PERCENTAGE;
